import { render } from "./ResellerList.vue?vue&type=template&id=7d9f4896&scoped=true"
import script from "./ResellerList.vue?vue&type=script&lang=js"
export * from "./ResellerList.vue?vue&type=script&lang=js"

import "./ResellerList.vue?vue&type=style&index=0&id=7d9f4896&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9f4896"]])

export default __exports__